import React from 'react';
import { DashboardMetrics as MetricsType } from '../../types/admin.types';
import './DashboardMetrics.css';

interface Props {
  metrics: MetricsType;
}

const DashboardMetrics: React.FC<Props> = ({ metrics }) => {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="dashboard-metrics">
      <div className="metrics-section">
        <h2 className="section-title">📅 Hoy</h2>
        <div className="metrics-grid">
          <div className="metric-card">
            <div className="metric-icon">📊</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.TodayTransactions}</div>
              <div className="metric-label">Transacciones</div>
            </div>
          </div>
          <div className="metric-card success">
            <div className="metric-icon">💵</div>
            <div className="metric-content">
              <div className="metric-value">{formatCurrency(metrics.TodayRevenue)}</div>
              <div className="metric-label">Ingresos</div>
            </div>
          </div>
          <div className="metric-card error">
            <div className="metric-icon">⚠️</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.TodayFailed}</div>
              <div className="metric-label">Fallidas</div>
            </div>
          </div>
        </div>
      </div>

      <div className="metrics-section">
        <h2 className="section-title">📆 Esta Semana</h2>
        <div className="metrics-grid">
          <div className="metric-card">
            <div className="metric-icon">📊</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.WeekTransactions}</div>
              <div className="metric-label">Transacciones</div>
            </div>
          </div>
          <div className="metric-card success">
            <div className="metric-icon">💵</div>
            <div className="metric-content">
              <div className="metric-value">{formatCurrency(metrics.WeekRevenue)}</div>
              <div className="metric-label">Ingresos</div>
            </div>
          </div>
          <div className="metric-card error">
            <div className="metric-icon">⚠️</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.WeekFailed}</div>
              <div className="metric-label">Fallidas</div>
            </div>
          </div>
        </div>
      </div>

      <div className="metrics-section">
        <h2 className="section-title">📅 Este Mes</h2>
        <div className="metrics-grid">
          <div className="metric-card">
            <div className="metric-icon">📊</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.MonthTransactions}</div>
              <div className="metric-label">Transacciones</div>
            </div>
          </div>
          <div className="metric-card success">
            <div className="metric-icon">💵</div>
            <div className="metric-content">
              <div className="metric-value">{formatCurrency(metrics.MonthRevenue)}</div>
              <div className="metric-label">Ingresos</div>
            </div>
          </div>
          <div className="metric-card error">
            <div className="metric-icon">⚠️</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.MonthFailed}</div>
              <div className="metric-label">Fallidas</div>
            </div>
          </div>
        </div>
      </div>

      <div className="metrics-section">
        <h2 className="section-title">📈 Estadísticas Generales</h2>
        <div className="metrics-grid">
          <div className="metric-card info">
            <div className="metric-icon">🎯</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.TotalTransactions}</div>
              <div className="metric-label">Total Histórico</div>
            </div>
          </div>
          <div className="metric-card success">
            <div className="metric-icon">💰</div>
            <div className="metric-content">
              <div className="metric-value">{formatCurrency(metrics.TotalRevenue)}</div>
              <div className="metric-label">Ingresos Totales</div>
            </div>
          </div>
          <div className="metric-card warning">
            <div className="metric-icon">⏳</div>
            <div className="metric-content">
              <div className="metric-value">{metrics.PendingProcessing}</div>
              <div className="metric-label">Pendientes</div>
            </div>
          </div>
          <div className="metric-card info">
            <div className="metric-icon">📊</div>
            <div className="metric-content">
              <div className="metric-value">{formatCurrency(metrics.AverageTransactionAmount)}</div>
              <div className="metric-label">Promedio por Transacción</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardMetrics;
